import { AudienceFilter, defineTopic } from 'magpie-lib/models';
import {
  navVisibilityControls,
  navConfigControls,
  navThemeControls,
  csatControls,
  papercutsControls,
  personalisedNavOptInControls,
  pinnedItemsApi,
  featuresApi,
  sidebarApi,
  publicApiAvailability,
} from '../messages';

export const NAVIGATION_PUBLIC_API_TOPIC_NAME =
  '@@navigation/public-api' as const;

export const navPublicApiAudience = AudienceFilter.builder().excludeSelf();

export const navigationPublicApiTopicDef = defineTopic({
  name: NAVIGATION_PUBLIC_API_TOPIC_NAME,
  messages: [
    navVisibilityControls.changeNavVisibility,
    navVisibilityControls.getNavVisibility,
    navVisibilityControls.navVisibilityChanged,
    navConfigControls.requestInvalidation,
    csatControls.scheduleCsatSurvey,
    csatControls.cancelScheduledCsatSurvey,
    csatControls.csatSurveyOpened,
    papercutsControls.show,
    papercutsControls.hide,
    papercutsControls.reposition,
    papercutsControls.pickingStart,
    papercutsControls.pickingEnd,
    personalisedNavOptInControls.getPersonalisedNavOptInStatus,
    personalisedNavOptInControls.personalisedNavOptInStatus,
    personalisedNavOptInControls.changePersonalisedNavOptInStatus,
    personalisedNavOptInControls.personalisedNavOptInStatusChangeResult,
    pinnedItemsApi.createGroup,
    pinnedItemsApi.renameGroup,
    pinnedItemsApi.removeGroup,
    pinnedItemsApi.pinnedItemsGroupChanged,
    featuresApi.getFeatures,
    featuresApi.features,
    sidebarApi.getSidebarStructure,
    sidebarApi.sidebarStructure,
    sidebarApi.toggleItem,
    sidebarApi.sidebarMutationResult,
    publicApiAvailability.publicApiAvailable,
    publicApiAvailability.isPublicApiAvailable,
    navThemeControls.changeNavTheme,
    navThemeControls.getNavTheme,
    navThemeControls.navTheme,
  ],
  enableRuntimeValidation: false,
  audience: navPublicApiAudience.build(),
});
